import { Screen } from '@fans-fund-me/shared-comm-react-cosmos/fans-fund-me/dashboard-screen';
import { useAuth } from '@fans-fund-me/shared-common-esm-authentication';
import { notifications } from '@mantine/notifications';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { getDashboard } from '../../api/dashboard.ts';
import { toStripeDashboard } from '../../api/payments.ts';
import { getRandomCreator } from '../../api/profile.ts';

function Dashboard() {
  const auth = useAuth();
  const navigate = useNavigate();

  const [id, setId] = useState<string | undefined>(undefined);
  const [view, setView] = useState<'sent' | 'received'>('received');
  const [isErrored, setIsErrored] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isStripeLoading, setIsStripeLoading] = useState(false);
  const [isRandomCreatorLoading, setIsRandomCreatorLoading] = useState(false);
  const [receivedGifts, setReceivedGifts] = useState({
    lastDaySummary: '',
    lastWeekSummary: '',
    allTimeSummary: '',
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    items: new Array(8).fill().map((_, i) => ({ id: `loading-received-gift-${i}` })),
  });
  const [sentGifts, setSentGifts] = useState({
    lastDaySummary: '',
    lastWeekSummary: '',
    allTimeSummary: '',
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    items: new Array(8).fill().map((_, i) => ({ id: `loading-sent-gift-${i}` })),
  });

  const toStripe = () => {
    setIsStripeLoading(true);

    setId(
      notifications.show({
        title: 'Sending you to Stripe',
        message: 'Please wait while we redirect you to your Stripe dashboard.',
        loading: true,
        color: 'white',
      }),
    );

    toStripeDashboard(auth.token).then((response) => {
      if (response.status === 200) {
        location.href = response.data.url;
      } else {
        setIsStripeLoading(false);
        if (id !== undefined) {
          notifications.update({
            id: id,
            title: 'Stripe Dashboard Error',
            message: 'There was a problem sending you to your dashboard. Please try again later.',
            autoClose: 7000,
            loading: false,
            color: 'red',
          });
        } else {
          notifications.show({
            title: 'Stripe Dashboard Error',
            message: 'There was a problem sending you to your dashboard. Please try again later.',
            autoClose: 7000,
            color: 'red',
          });
        }
      }
    });
  };

  const handleClickRandomCreator = () => {
    setIsRandomCreatorLoading(true);
    localStorage.removeItem('ffm_payment_complete_redirect_to');
    getRandomCreator()
      .then((response) => {
        navigate(`/${response.data.username}`);
      })
      .catch((error) => console.error('Error getting random creator', JSON.stringify(error)));
  };

  useEffect(() => {
    setIsLoading(true);
    if (auth.token !== undefined && auth.token !== '' && auth.id !== undefined && auth.id !== '') {
      getDashboard(auth.token, auth.id, 'UTC')
        .then((response) => {
          const received = {
            lastDaySummary: response.data.received.lastDaySummary.formattedAmountReceived,
            lastWeekSummary: response.data.received.lastWeekSummary.formattedAmountReceived,
            allTimeSummary: response.data.received.allTimeSummary.formattedAmountReceived,
            items: response.data.received.payments,
          };

          const sent = {
            lastDaySummary: response.data.sent.lastDaySummary.formattedAmountReceived,
            lastWeekSummary: response.data.sent.lastWeekSummary.formattedAmountReceived,
            allTimeSummary: response.data.sent.allTimeSummary.formattedAmountReceived,
            items: response.data.sent.payments,
          };

          setReceivedGifts(received);
          setSentGifts(sent);
          setIsLoading(false);
        })
        .catch((error) => {
          console.error('Error getting dashboard information', JSON.stringify(error));
          setIsErrored(true);
          setIsLoading(false);
        });
    }
  }, [auth.id, auth.token]);

  return (
    <Screen
      view={view}
      setView={setView}
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-expect-error
      sentGifts={sentGifts}
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-expect-error
      receivedGifts={receivedGifts}
      isErrored={isErrored}
      isLoading={isLoading}
      isStripeLoading={isStripeLoading}
      isRandomCreatorLoading={isRandomCreatorLoading}
      handleClickStripeDashboard={toStripe}
      handleClickRandomCreator={handleClickRandomCreator}
    />
  );
}

export default Dashboard;
